import { useQuery } from "react-query";
import { getCardReaderById } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetCardReaderId = (recNumber) => {
  return useQuery(
    ["GetCardReaderByRecordNumber", recNumber],
    () => getCardReaderById(recNumber),
    { refetchOnWindowFocus: false }
  );
};
